export default {
  container: {
    padding: '2rem',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    marginBottom: '2rem'
  },
  backButton: {
    fontSize: '1rem'
  },
  title: {
    fontWeight: 'bold',
    color: '#333'
  },
  paper: {
    padding: '2rem',
    borderRadius: '8px'
  },
  statusSection: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '1rem'
  },
  statusChip: {
    fontSize: '1.1rem',
    padding: '1.5rem 1rem',
    height: 'auto'
  },
  infoBox: {
    padding: '1rem',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px'
  },
  label: {
    fontWeight: 'bold',
    color: '#666',
    marginBottom: '0.5rem'
  },
  actionsSection: {
    marginTop: '2rem'
  },
  fileButtons: {
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap'
  },
  downloadButton: {
    minWidth: '200px'
  },
  inquiriesSection: {
    marginTop: '2rem'
  }
};

